module.exports = __webpack_public_path__ + "img/icon_arrow.dc4b9070.e83de18f.svg";